function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from '../layout.scss';

var AVITile = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AVITile, _Component);

  function AVITile() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = AVITile.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        width = _this$props.width,
        height = _this$props.height,
        color = _this$props.color;
    var tileClasses = "avi-tile flex" + width + " " + (height ? "row" + height : '');
    return /*#__PURE__*/React.createElement("div", {
      className: tileClasses
    }, /*#__PURE__*/React.createElement("div", {
      className: 'avi-tile-padding tile-padding'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'avi-tile-content tile-content'
    }, children)));
  };

  return AVITile;
}(Component);

_defineProperty(AVITile, "defaultProps", {
  color: 'white'
});

export { AVITile as default };
AVITile.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  width: PropTypes.number.isRequired,
  color: PropTypes.string,
  height: PropTypes.number
} : {};